var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUscCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 49 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.4-Event-Overview-USC-Error",
    transform: "translate(-1097.000000, -286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-Standard",
    transform: "translate(1097.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTN-/-S-/-USC-/-Connected"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#E1E1E1",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 27,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(30.000000, 9.000000)",
    fillRule: "nonzero",
    stroke: "#ED2F2F",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 11,
    y2: 11,
    id: "Line-2-Copy-2",
    transform: "translate(5.500000, 5.500000) scale(-1, 1) translate(-5.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 11,
    y2: 11,
    id: "Line-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 5.000000)",
    fill: "#383E41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7996891,3.59989484 L12.5996358,3.59989484 L12.5996358,0 L8.99974245,0 L8.99974245,1.79994742 L10.7996891,1.79994742 L10.7996891,1.79994742 L10.7996891,3.59989484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5996312,11.6996574 L12.5996312,5.39984168 L10.7996839,5.39984168 L10.7996839,11.6996574 C10.7996839,14.184866 8.78502432,16.1995258 6.29981558,16.1995258 C3.81460685,16.1995258 1.79994731,14.184866 1.79994731,11.6996574 L1.79994731,1.79994723 L7.19978924,1.79994723 L7.19978924,0 L0,0 L0,11.6996574 C0,15.1792403 2.8207598,18 6.30034292,18 C9.77992605,18 12.6006858,15.1792403 12.6006858,11.6996574",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Context-Menu",
    transform: "translate(602.555556, 30.500000) rotate(90.000000) translate(-602.555556, -30.500000) translate(596.055556, 29.055556)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Color",
    fill: "#738A9E",
    xlinkHref: "#path-4"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUscCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/USCCross.267cffff.svg";
export { ForwardRef as ReactComponent };